import React, { useState, useRef, useEffect, useMemo } from 'react';
import CommonTable from '../../components/Table/CommonTable';
import JoditEditor from 'jodit-react';
import './WebBlog.css'
import 'react-datepicker/dist/react-datepicker.css'
import Loader from '../../components/Loader/Loader';
import { toast } from 'react-toastify';
import { API_END_POINT, API_END_POINT_NOAUTH, TOKEN } from '../../constant';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';


function WebBlog() {
  const [showForm, setShowForm] = useState(false);
  const [btnName, setBtnName] = useState("Add");
  const [content, setContent] = useState('');
  const editor = useRef(null);
  const [blogName, setBlogName] = useState('')
  const [editId, setEditId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState('')
  const [imageLink, setImageLink] = useState('')
  const [showUpdateForm, setShowUpdateForm] = useState(false)
  const [webblogsList, setWebblogsList] = useState([]);
  const [imageId, setImageId] = useState(null)
  const [isSchedule, setIssSchedule] = useState(false)
  const [description, setDescription] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const [blogDate, setBlogDate] = useState(new Date())
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState();
  const [blogDetails, setBlogDetails] = useState();
  const [searchText, setSearchText] = useState('');
  const [selectedCategory, setselectedCategory] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState([])
  const [categoryInput, setCategoryInput] = useState();
  const [slugTitle, setSlugTitle] = useState("")


  useEffect(() => {
    console.log("thsi is current page now ", currentPage)
    getWebBlogList();
  }, [currentPage])

  useEffect(() => {
    console.log("called--->>>")
    getCategoryList();
  }, [])

  const handlePageChange = (page) => {
    console.log("this is change page", page)
    setCurrentPage(page);
  };

  const config = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing here...',
    toolbar: true,
    resizer: true,
    style: {
      overflow: 'auto'
    },
  }), []);


  const deleteWebBlog = async (id) => {
    setLoading(true)
    const deleteWebBlogUrl = `${API_END_POINT}web-blog/delete`
    const deleteWebBlogHeaders = {
      'Authorization': `Bearer ${TOKEN}`
    }

    try {
      const response = await fetch(`${deleteWebBlogUrl}/${id}`, { method: 'DELETE', headers: deleteWebBlogHeaders })
      if (!response.ok) {
        toast.error(`Error while deleting the WebBlog with id - ${id}`);
        return
      }
      toast.success("WebBlog deleted Successfully")
      getWebBlogList(currentPage);
    } catch (error) {
      console.log('Error while deleting WebBlog --->>> deleteWebBlog() ', error);
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = (id) => {
    deleteWebBlog(id);
  };

  const handleSlugTitlechange = (e) => {
    console.log("this is slug title --->>>> ", e.target.value)
  }

  const getWebBlogList = async () => {
    console.log("Fetching page:", currentPage);
    setLoading(true);
    const getWebBlogListUrl = `${API_END_POINT_NOAUTH}web-blog/get-list?page=${currentPage - 1}&size=21&categoryId=`;
    try {
      const response = await fetch(getWebBlogListUrl, { method: 'GET' });
      if (!response.ok) {
        toast.error("failed to fetch web blog list");
        return;
      }

      const responseData = await response.json();
      setWebblogsList(responseData.data.blogs);
      setTotalRows(responseData.data.pagination.totalElements);
    } catch (error) {
      console.log('Error fetching web blogs list --->>> getWebBlogList()', error);
    } finally {
      setLoading(false);
    }
  };

  const getWebBlogListBySearch = async (e) => {
    e.preventDefault();
    // console.log("Fetching page:", currentPage);
    // setLoading(true);
    const getWebBlogListUrl = `${API_END_POINT_NOAUTH}web-blog/get-list?page=${currentPage - 1}&size=21&searchKeyword=${e.target.value}`;
    try {
      const response = await fetch(getWebBlogListUrl, { method: 'GET' });
      if (!response.ok) {
        toast.error("failed to fetch web blog list");
        return;
      }

      const responseData = await response.json();
      setWebblogsList(responseData.data.blogs);
      setTotalRows(responseData.data.pagination.totalElements);
    } catch (error) {
      console.log('Error fetching web blogs list --->>> getWebBlogListBySearch()', error);
    } finally {
      setLoading(false);
    }
  };


  const handleFormUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    const createdOnFormattedData = moment(blogDate).format('DD/MM/YYYY');
    console.log("Formatted Date:", createdOnFormattedData);

    const updateWebBlogUrl = `${API_END_POINT}web-blog/update/${editId}`;
    const updateData = {
      title: blogName,
      content: content,
      imageFileId: imageId,
      metadata: description,
      webBlogDate: createdOnFormattedData,
      blogCategory: selectedCategory, 
      urlSlug: slugTitle,
    };


    const updateWebBlogHeaders = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`,
    };

    try {
      const response = await fetch(updateWebBlogUrl, {
        method: 'PUT',
        headers: updateWebBlogHeaders,
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        toast.error('Failed to update the WebBlog');
        return;
      }

      toast.success('Blog has been updated successfully');

      // Reset form state
      setShowUpdateForm(false);
      setBlogName('');
      setContent('');
      setImageId(null); 
      setDescription('');
      setBlogDate(new Date()); 
      setShowUpdateForm(false)
      getWebBlogList(currentPage);

    } catch (error) {
      console.error('Error updating blog --->>> handleFormUpdate():', error);
      toast.error('An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };


  const formatDate = (date) => {
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
  };

  const handleUpdate = (blogId) => {
    if (!showUpdateForm) {
      fetchBlogDetails(blogId);
    } else {
      setIssSchedule(false);
    }
    setShowUpdateForm(prevState => !prevState)
  }

  const fetchBlogDetails = async (blogId) => {
    setLoading(true)
    const getBlogDetailsUrl = `${API_END_POINT_NOAUTH}get/${blogId}`;
    try {
      const response = await fetch(getBlogDetailsUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log("data ji -> ", data)
      const blog = data.data;
      console.log("the data is ", blog)
      console.log("this is category id ---->>>>", blog.blogCategory.value)
      // setBlogDetails(blog); 
      setContent(blog.content)
      setBlogName(blog.title)
      setEditId(blog.id)
      setSelectedFile(blog.mainBlogImage)
      setDescription(blog.metaData)
      setselectedCategory(blog.blogCategory.value)
      setSlugTitle(blog.urlSlug)
      const blogCreatedOnDate = new Date(blog.createdOn.split('/').reverse().join('-')); // '2025-03-25'

      setBlogDate(blogCreatedOnDate)
      console.log("this is the blog date ", blogCreatedOnDate)
    } catch (error) {
      console.error("Failed to fetch blog details:", error);
    } finally {
      setLoading(false)
    }
  };

  const addNewBlog = async () => {
    const addWebBlogUrl = `${API_END_POINT}web-blog/save`

    const addWebBlogHeaders = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    };

    let correctedContent = content.replace(/\\"/g, '"');

    console.log("correctContent", correctedContent)


    console.log("content", correctedContent)
    const data = {
      'title': blogName,
      'content': correctedContent,
      'imageFileId': imageId,
      'metadata': description,
      'blogCategory': selectedCategory,
      'urlSlug': slugTitle,
      ...(isSchedule ? { 'scheduledPublishDate': formatDate(blogDate) } : { 'webBlogDate': formatDate(blogDate) })
    };

    console.log("this is data", data)

    console.log("this is json", JSON.stringify(data))

    try {
      const response = await fetch(addWebBlogUrl, {
        method: 'POST',
        headers: addWebBlogHeaders,
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        toast.error('Failed to save the blog');
        return;
      }

      const result = await response.json();

      toast.success("WebBlog has been Uploaded Successfully!");

      setBlogName('');
      setDescription('');
      setContent('');
      setImageId(null)
      setSelectedFile('')
      setIssSchedule(false)
      getWebBlogList(currentPage);
      setShowForm(false)

    } catch (error) {
      console.error('Error saving the blog --->>> addNewBlog()', error);
    } finally {
      setLoading(false);
    }
  }


  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!blogName || !content || !imageId || !description) {
      toast.error("Blog name or blog content or mainImage can't be empty");
      return;
    }
    setLoading(true)
    addNewBlog();
  }



  const handleCheckboxChange = () => {
    setIssSchedule(prevState => !prevState);
  };

  const handleMainImageUpdate = async (e) => {
    setLoading(true)
    e.preventDefault();

    if (!selectedFile) {
      toast.error('No image selected! Please select an image.');
      setLoading(false);
      return;
    }

    console.log('Selected file:', selectedFile);

    const formData = new FormData();
    formData.append('File', selectedFile);
    formData.append('webBlogId', editId);

    try {
      const response = await fetch(`${API_END_POINT}web-blog/upload`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: formData,
      });

      if (!response.ok) {
        toast.error("Error while uploading image");
        return;
      }

      const data = await response.json();
      toast.success("Webblog inzage updated Successfully")
      console.log("Response updated image:", data);

    } catch (error) {
      console.error("Error while updating image --->>> handleMainImageUpdate()", error);
    } finally {
      setLoading(false);
    }
  };

const slugify = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s\-अ-हअ-ऑआ-औऋ-ॠऩ-ॼ0-9\s-]/g, '')  
    .replace(/\s+/g, '-') 
    .replace(/-+/g, '-'); 
};


  const addBlogCategory = async (value) => {
    if (!value) {
      toast.error("blog category is empty")
      return;
    }
    const addBlogCategoryUrl = `${API_END_POINT}blog-category/save?categoryName=${value}`
    const addBlogCategoryHeaders = {
      'Authorization': `Bearer ${TOKEN}`
    }
    console.log("this is the entered value", value)

    try {
      const response = await fetch(addBlogCategoryUrl, {
        method: 'POST',
        headers: addBlogCategoryHeaders
      })

      if (!response.ok) {
        toast.error("failed to add category")
      }

      toast.success("blog category added successfully")
      getCategoryList();
    } catch (error) {
      console.log("WebBlog --->>> addBlogCategory() --->>> ", error)
    } finally {
      setIsOpen2(false)
    }

  }



  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      toast.error("No file selected");
    }
  };
  const handleUpload = async () => {
    setLoading(true)
    if (!selectedFile) {
      toast.error('No image selected! Please select an image.');
      setLoading(false)
      return
    }
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`${API_END_POINT}fileAttachment/uploadImages`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Failed to upload image');
      }
      const data = await response.json();
      console.log("object", data.data)
      console.log("this image link is ", data.data.fileLinkString)
      toast.success('Image uploaded successfully!');
      setImageLink(`https://api.kundaliexpert.com/kmAstroapp/api/v1/${data.data.fileLinkString}`)
      setIsOpen(true);
      setSelectedFile(null)
    } catch (error) {
      console.log('Error uploading image --->>> handleUpload() ', error);
    }
    finally {
      setLoading(false)
    }
  };

  const handleAddBlogCategory = (e) => {
    e.preventDefault();
    setIsOpen2(prevState => !prevState)
  }

  const handleMainImageUpload = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (!selectedFile) {
      toast.error('No image selected! Please select an image.');
      setLoading(false)
      return
    }
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`${API_END_POINT}fileAttachment/uploadImages`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: formData,
      });
      if (!response.ok) {
        toast.error('Failed to upload image');
      }
      const data = await response.json();
      console.log("object", data)
      console.log("this image link is ", data.data.fileId)
      toast.success('Image uploaded successfully!');
      setImageId(data.data.fileId)
      console.log("image id ", imageId)
    } catch (error) {
      console.log('Error uploading image --->>> handleMainImageUpload() ', error);
    }
    finally {
      setLoading(false)
    }
  };

  const getCategoryList = async () => {
    setLoading(true)
    const getCategoryListUrl = `${API_END_POINT_NOAUTH}blog-category/list`
    const getCategoryListHeaders = {
      'Authorization': `Bearer ${TOKEN}`
    }
    try {
      const response = await fetch(getCategoryListUrl, {
        method: 'GET',
        headers: getCategoryListHeaders
      })

      if (!response.ok) {
        toast.error('failed to fetch category list')
      }

      const categoryListResponse = await response.json();
      console.log("this is webblog category lisr", categoryListResponse.data)
      // toast.success('wwebll')
      setCategoryOptions(categoryListResponse.data)
    } catch (error) {
      console.log('WeBlog --->>> getCategoryList() --->>>', error)
    }
    finally {
      setLoading(false)
    }
  }




  const addRow = () => {
    setBlogName('')
    setContent('')
    if (btnName === "Save") {
      setBtnName("Add");
    }
    setShowForm(!showForm);
  };

  const columns = [
    {
      name: 'Sr. No.',
      cell: (row, index) => row.id,
    },
    {
      name: "Web-Blog Name",
      cell: (row) => row?.title,
    },
    {
      name: "Web-Blog Date",
      cell: (row) => row?.createdOn,
    },
    {
      name: "Image",
      cell: (row) => <img
        title='Click to see Image'
        src={`${API_END_POINT}${row?.mainBlogImage}`}
        width={"90%"}
        height={"90%"}
        alt="Blog Image"
      />
    },
    {
      name: "Views",
      cell: (row) => row?.seenCount || 0,
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div className='flex align-center gap-10'>
          <button className='edit-btn'
            onClick={() => {
              handleUpdate(row.id);
            }}>
            <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="m7 17.011 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.581v4.43ZM18.045 4.456l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58ZM9 13.416l6.03-5.974 1.586 1.586L10.587 15 9 15.004v-1.589Z"></path>
              <path d="M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2Z"></path>
            </svg>
          </button>
          <button className='flex align-center delete-btn-icon' onClick={() => handleDelete(row.id)}>
            <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2v12ZM9 4h6v2H9V4ZM8 8h9v12H7V8h1Z"></path>
              <path d="M9 10h2v8H9v-8Zm4 0h2v8h-2v-8Z"></path>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <main className='main'>
      {!loading ? (
        <div className='webBlogContainer'>
          <section>
            <h3 className='heading'>Web-Blog</h3>
            <div className='flex flex-row justify-between' style={{ marginTop: '10px', flexWrap: 'wrap', alignItems: 'center' }}  >
              <div className='fileuploadcontainer' style={{ alignItems: 'center' }}>
                <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                <button className='common-btn flex align-center' style={{ height: '40px' }} onClick={handleUpload}>
                  Upload Image
                </button>
              </div>
              <div className='input-field flex ' style={{ alignItems: 'center', gap: '8px', }} >
                <label htmlFor="searchName">Search Bar</label>
                <input style={{ padding: '10px', borderRadius: '10px', width: '300px' }} type="text" id='searchName' placeholder='Search Here' onChange={getWebBlogListBySearch} />
              </div>
            </div>
            <div style={{ marginTop: "10px" }} className='flex align-center justify-end'>
              <button onClick={addRow} className='common-btn flex align-center'>
                {!showForm ? "Add Webblog" : "Cancel"}
              </button>
            </div>
            {showForm && (
              <>
                <form className='form'>
                  <div className='input-field flex flex-col'>
                    <label htmlFor="blogName">Web-Blog Name</label>
                    <input
                      id='blogName'
                      type="text"
                      name="blogName"
                      value={blogName}
                      onChange={(e) => {
                        const name = e.target.value;
                        setBlogName(name);
                        setSlugTitle(slugify(name));
                      }}
                      placeholder="Enter Webblog Name"
                    />
                  </div>
                  <div className='input-field flex flex-col'>
                    <label htmlFor="blogName">Slug Title</label>
                    <input
                      id='slugTitle'
                      type="text"
                      name="slugTitle"
                      value={slugTitle}
                      onChange={(e) => setSlugTitle(slugify(e.target.value))} 
                      placeholder="Auto-generated Slug"
                    />

                  </div>
                  <div className='input-field flex flex-col'>
                    <label htmlFor="blogName">Web-Blog Description</label>
                    <input
                      id='blogName'
                      type="text"
                      name="blogName"
                      value={description}
                      onChange={(e) => (setDescription(e.target.value))}
                      placeholder="Enter Webblog Description"
                    />
                  </div>
                  <div>
                    <label htmlFor="blogName">Main Web-Blog Image</label>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
                      <div>
                        <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                        <button style={{ width: 'fit-content', height: '40px' }} className='common-btn align-center' onClick={handleMainImageUpload}>
                          Add Main Image
                        </button>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <label className="custom-checkbox">
                          <Select
                            defaultValue={selectedCategory}
                            onChange={(option) => {
                              setselectedCategory(option.value);
                            }}
                            options={categoryOptions}
                            placeholder='Select blog category'
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: 300,
                              }),
                            }}
                          />
                        </label>
                        <button style={{ width: 'fit-content', height: '40px' }} className='common-btn align-center' onClick={handleAddBlogCategory}>
                          Add Blog Category
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      <label htmlFor="blogDate">Web-Blog Date</label>
                      <DatePicker id='fileupload' selected={blogDate} onChange={blogDate => { setBlogDate(blogDate) }} dateFormat='dd/MM/yyyy' showYearDropdown scrollableYearDropdown />
                    </div>
                    <div>
                      <label className="custom-checkbox">
                        <input type="checkbox" name="Fast and Festival" checked={isSchedule} onChange={handleCheckboxChange} className="checkbox-input" />
                        Schedule this blog?
                      </label>
                    </div>

                  </div>
                  <div>
                    <JoditEditor
                      ref={editor}
                      value={content}
                      config={config}
                      tabIndex={1}
                      onBlur={newContent => setContent(newContent)}
                      onChange={newContent => { }}
                    />
                  </div>
                  <div className='buttons flex flex-col'>
                    <button type="submit" onClick={handleFormSubmit} className='btn'>{btnName}</button>
                  </div>
                </form>
              </>
            )}
            {showUpdateForm && (
              <form className='form'>
                <div className='input-field flex flex-col'>
                  <label htmlFor="blogName">Web-Blog Name</label>
                 <input
                      id='blogName'
                      type="text"
                      name="blogName"
                      value={blogName}
                      onChange={(e) => {
                        const name = e.target.value;
                        setBlogName(name);
                        setSlugTitle(slugify(name));
                      }}
                      placeholder="Enter Webblog Name"
                    />
                </div>
                <div className='input-field flex flex-col'>
                    <label htmlFor="blogName">Slug Title</label>
                    <input
                      id='slugTitle'
                      type="text"
                      name="slugTitle"
                      value={slugTitle}
                      onChange={(e) => setSlugTitle(slugify(e.target.value))} 
                      placeholder="Auto-generated Slug"
                    />

                  </div>
                <div className='input-field flex flex-col'>
                  <label htmlFor="blogName">Web-Blog Description</label>
                  <input
                    id='blogName'
                    type="text"
                    name="blogName"
                    value={description}
                    onChange={(e) => (setDescription(e.target.value))}
                    placeholder="Enter Webblog Description"
                  />
                </div>
                <div>
                  <label htmlFor="blogName">Main Web-Blog Image</label>
                  <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div>
                      <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                      <button style={{ width: 'fit-content', height: '40px' }} className='common-btn align-center' onClick={handleMainImageUpload}>
                        Update Main Image
                      </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                      <label className="custom-checkbox">
                        <Select
                          defaultValue={selectedCategory}
                          onChange={(option) => {
                            setselectedCategory(option.value);
                          }}
                          options={categoryOptions}
                          placeholder='Select blog category'
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: 300,
                            }),
                          }}
                        />
                      </label>
                      <button style={{ width: 'fit-content', height: '40px' }} className='common-btn align-center' onClick={handleAddBlogCategory}>
                        Add Blog Category
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <label htmlFor="blogDate">Web-Blog Date</label>
                  <DatePicker id='fileupload' selected={blogDate} onChange={blogDate => { setBlogDate(blogDate) }} dateFormat='dd/MM/yyyy' showYearDropdown scrollableYearDropdown />
                </div>
                <JoditEditor
                  ref={editor}
                  value={content}
                  tabIndex={1}
                  onChange={newContent => {
                    if (newContent !== content) {
                      setContent(newContent);
                    }
                  }}
                />
                <div className='buttons flex flex-col'>
                  <button type="submit" onClick={handleFormUpdate} className='btn'>Update</button>
                </div>
              </form>
            )}

          </section>
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}

      <div>
        {isOpen && (
          <div className="popup" onClick={(e) => {
            if (e.target.classList.contains('popup')) {
              setIsOpen(false)
            }
          }}>
            <div className="popup-content">
              <h6>copy image link </h6>
              <span className="close-btn" onClick={(e) => (setIsOpen(false))}>&#10005;</span>
              <div style={{ fontSize: 12 }} >{imageLink}</div>
            </div>
          </div>
        )}
      </div>

      <div>
        {isOpen2 && (
          <div className="popup" onClick={(e) => {
            if (e.target.classList.contains('popup')) {
              setIsOpen2(false)
            }
          }}>
            <div className="popup-content">
              <h6>Add Category Name </h6>
              <input style={{ borderRadius: '5px' }} type="text" name="" id="category-name" />
              <span className="close-btn" onClick={(e) => (setIsOpen2(false))}>&#10005;</span> <br />
              <button className='common-btn align-center'
                id="popupbutton"
                onClick={() => addBlogCategory(document.getElementById('category-name').value)}
              >
                Add Category
              </button>

            </div>
          </div>
        )}
      </div>



      <div style={{ marginTop: "10px" }}>
        <CommonTable
          columns={columns}
          data={webblogsList}
          handlePageChange={handlePageChange}
          value={true}
          totalRows={totalRows}
        />
      </div>
    </main>
  );
}

export default WebBlog;
